import api from "../index";
import { apiUrl } from "../../utils/constants";

export const CreateAlert = (data) => api.post(apiUrl.alerts, data);
export const UpdateAlert = (id, data) =>
  api.put(`${apiUrl.alerts}/${id}`, data);
export const GetAlerts = (params) => api.get(apiUrl.alerts, { params });
export const GetSingleAlert = (id) => api.get(`${apiUrl.alerts}/${id}`);
export const DeleteSingleAlert = (id) => api.delete(`${apiUrl.alerts}/${id}`);
